import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

function Link(props) {
  const { children, block, tag, className, ...rest } = props;

  return React.createElement(
    tag || "a",
    {
      className: cx(
        "italic text-blue-600 underline",
        { block: block },
        className
      ),
      ...rest,
    },
    children
  );
}

Link.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  tag: PropTypes.node,
  block: PropTypes.bool,
  className: PropTypes.string,
};

Link.defaultProps = {
  tag: "a",
  block: true,
  className: "",
};

export default Link;
